import { LoadingPage } from "@/components/loading-page";
import { useAuth } from "@/providers/auth";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SSOPage() {
    const [loading, setLoading] = useState(true);
    const { authenticated, refresh } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleRefresh = async () => {
            await refresh();
            setLoading(false);
        };
        handleRefresh();
    });

    useEffect(() => {
        if (!loading) {
            if (location.hash != "#error") {
                // A magic link may name the page to land on: a local path only, never another site.
                const next = new URLSearchParams(location.search).get("next");
                const fromLink = next && next.startsWith("/") && !next.startsWith("//") && !next.includes("\\") ? next : null;
                const sso_destination = fromLink || localStorage.getItem("redirect") || "/";
                localStorage.removeItem("redirect");
                if (authenticated) {
                    navigate(sso_destination);
                } else {
                    navigate("/connexion");
                }
            }
        }
    }, [loading, authenticated, navigate, location]);

    return <>{location && location.hash == "#error" ? <p>Une erreur est survenue lors de la connexion</p> : <LoadingPage />}</>;
}
